export default {
  title: 'Suspendare Disponibilitate',
  description: 'Rezervări epuizate?',
  pause_availabilities: {
    pause_until_end_of_day: 'Suspendați rezervările până la sfârșitul zilei?',
    pause_specific_time: 'Suspendați rezervările pentru o altă zi și/sau oră',
  },
  pause_reservations_today: 'Suspendați Rezervările Azi',
  pause_reservations_another_day: 'Suspendați Rezervările pentru Altă Zi',
  paused_availabilities_form: {
    date_time: {
      label: 'Selectați o Dată și oră',
    },
    reason: {
      label: 'Adăugați un motiv (opțional)',
      placeholder: 'Introduceți descrierea...',
    },
  },
  buttons: {
    save: 'Salvați',
  },
  error_messages: {
    creation_failed: 'Crearea excepției a eșuat',
  },
};
